import SingleLine from "../../../components/codeContainer/SingleLine";

const BaseURI = () => (
    <section>
        <div className="anchor-point" id="section-1" />
        <h1>Base URI</h1>
        <hr/>

        <SingleLine>{"https://gomorra-api.onrender.com/"}</SingleLine>

    </section>
)

export default BaseURI